"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "PermissionSimplePage",
  props: {
    permission: {
      type: Boolean,
      required: true
    }
  }
};
exports.default = _default;